import { Form, Input, Select } from 'antd'

const { TextArea } = Input

const StepTwo = () => {
  const reasonOptions = [
    {
      value: '1',
      label: 'Não estou usando o serviço com frequência',
    },
    {
      value: '2',
      label: 'Encontrei outra solução que atende melhor às minhas necessidades',
    },
    {
      value: '3',
      label: 'Tive dificuldades técnicas ou problemas de funcionamento',
    },
    {
      value: '4',
      label: 'Faltam recursos ou funcionalidades que eu gostaria de ter',
    },
    {
      value: '5',
      label: 'Preço da assinatura é muito alto',
    },
    {
      value: '6',
      label: 'Outro motivo (quero explicar melhor)',
    },
  ]

  return (
    <>
      <Form.Item
        name="reason"
        label={
          <span>
            <span style={{ color: 'red' }}>* </span>
            Por que você está cancelando a assinatura?
          </span>
        }
        rules={[{ required: true, message: '' }]}
      >
        <Select
          size="large"
          placeholder="Escolha um motivo"
          options={reasonOptions}
          style={{ borderRadius: 6 }}
        />
      </Form.Item>

      <Form.Item name="feedback" label="Feedback">
        <TextArea
          rows={4}
          placeholder="Deixe seu feedback"
          maxLength={500}
          showCount
          style={{ borderRadius: 6 }}
        />
      </Form.Item>
    </>
  )
}

export default StepTwo
